import React, { useState, useMemo, useEffect } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard'
import { useSelector } from 'react-redux';
import ReactPaginate from "react-paginate";
import { useTable, useSortBy, usePagination } from "react-table";
import { BsArrowDown, BsArrowUp, BsArrowDownUp } from 'react-icons/bs';
import { FiRefreshCcw } from 'react-icons/fi'
import { MdContentCopy } from 'react-icons/md'
import { RiArrowDownSLine, RiArrowRightSLine, RiArrowUpSLine } from 'react-icons/ri';
import { Collapse, Row, Col, Input, Label, Button, Table } from 'reactstrap'

import { COLUMNS_USUARIO } from "./constants/columns";

import * as controller from '../../controllers/inconsistenciasProducaoController'
import { notifySuccess, notifyWarn } from '../../components/message/message';
import { removeAccentsAndUppercase } from '../../util/masks';

function agruparPorUsuarioEBanco(usuarios) {
    const grupos = []
    usuarios.forEach((registro) => {
        const chave = `${registro.usuario}|${registro.bancoId}`
        const grupo = grupos.find((g) => g.chave === chave)
        if (grupo) {
            grupo.arquivos.push(registro)
        } else {
            grupos.push({
                chave,
                usuario: registro.usuario,
                bancoId: registro.bancoId,
                instituicao: registro.instituicao,
                arquivos: [registro],
            })
        }
    })
    return grupos
}

function correspondeABusca(grupo, termo) {
    const valores = [
        grupo.usuario,
        grupo.instituicao,
        ...grupo.arquivos.map((arquivo) => arquivo.nomeArquivoImportado),
        ...grupo.arquivos.flatMap((arquivo) => arquivo.propostas.map((proposta) => proposta.numeroProposta)),
    ]
    return valores.some((valor) => removeAccentsAndUppercase(String(valor ?? '')).includes(termo))
}

export default function Usuario(){
    const { usuarios, tab} = useSelector(state => state.inconsistenciaProducao);
    const [busca, setBusca] = useState('')

    const grupos = agruparPorUsuarioEBanco(usuarios)
    const termo = removeAccentsAndUppercase(busca.trim())
    const gruposFiltrados = termo ? grupos.filter((grupo) => correspondeABusca(grupo, termo)) : grupos

    return(
        <div style={{width: '93%', marginLeft: '25px'}}>
            <Row style={{marginTop: '20px'}}>
                <Col md={6}>
                    <Input
                        type="text"
                        placeholder="Busque por usuário, instituição, proposta ou arquivo..."
                        value={busca}
                        onChange={(e) => setBusca(e.target.value)}
                    />
                </Col>
            </Row>
            {gruposFiltrados.map((grupo)=>{
                return(
                    <CollapsedCard key={grupo.chave} grupo={grupo} tab={tab}/>
                )
            })}
        </div>
    )
}

function CollapsedCard({grupo, tab}){
    const { tabs, usuarios } = useSelector(state => state.inconsistenciaProducao);

    const columns = useMemo(() => COLUMNS_USUARIO, []);

    const chaveDados = grupo.arquivos.map((arquivo) => `${arquivo.planilhaId}:${arquivo.propostas.length}`).join('|')
    const data = useMemo(
        () => grupo.arquivos.flatMap((arquivo) =>
            arquivo.propostas.map((proposta) => ({ ...proposta, nomeArquivo: arquivo.nomeArquivoImportado }))
        ),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [chaveDados]
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        prepareRow,
        gotoPage,
        state,
        setPageSize,
    } = useTable({
        columns,
        data
    },
        useSortBy,
        usePagination);

    const { pageSize } = state;
    const [rows, setRows] = useState(0);
    const [initialPage, setInitialPage] = useState(false);
    const [selectedPage, setSelectedPage] = useState(null);

    useEffect(() => {
        setRows(page.length);
    }, [page])

    useEffect(() => {
        setPageSize(5);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handlePageClick = (e) => {
        const pageSelected = e.selected;
        setInitialPage(false);
        setSelectedPage(pageSelected);
        gotoPage(pageSelected);
    }

    const pageCount = Math.ceil(data.length / pageSize);

    const [isCardOpen, setIsCardOpen] = useState(false)

    function handleCorrigirInconsistencia(){
        const baseURL = window.location.origin
        window.open(`${baseURL}/personas?usuarioInstituicao=${encodeURIComponent(grupo.usuario)}`)
    }

    async function handleExpandir(){
        setIsCardOpen(true)
        for (const arquivo of grupo.arquivos) {
            await controller.getPropostas(arquivo.planilhaId, arquivo.usuario, usuarios)
        }
    }

    async function handleRefresh(){
        if (grupo.arquivos.some((arquivo) => !arquivo.propostas?.[0]?.dataEntradaProposta)) {
            return notifyWarn('Expanda a inconsistencia antes de corrigi-la')
        }
        for (const arquivo of grupo.arquivos) {
            await controller.correcaoInconsistencia(arquivo, tab, usuarios)
        }
        await controller.getQuantidade(tabs)
    }
    return(
        <div style={{borderTop: '1px solid #CCCFDE', marginBottom: '30px'}}>
            <div style={{display: 'flex', marginTop: '30px'}}>
                <div style={{width: '95%'}}>
                    <Row>
                        <Col md={3}>
                            <Label style={{fontWeight: 'bold'}}>Usuário</Label>
                            <div style={{display: 'flex', border: '1px solid var(--color-laranja)', borderRadius: '0.25rem', padding: '8px 0 8px 10px', background: '#E9ECEF'}}>
                                <p style={{width: '95%', margin: '0'}}>
                                   {grupo.usuario}
                                </p>
                                <CopyToClipboard text={grupo.usuario} onCopy={()=> notifySuccess('Copiado!')}>
                                    <button style={{background: 'transparent', border: 'none'}}> <MdContentCopy style={{color: 'var(--color-verde-claro)', marginRight: '10px'}}/></button>
                                </CopyToClipboard>
                            </div>
                        </Col>
                        <Col md={3}>
                            <Label style={{fontWeight: 'bold'}}>Instituição Financeira</Label>
                            <Input
                                type="text"
                                placeholder="Busque um favorecido..."
                                value={grupo.instituicao}
                                disabled
                            />
                        </Col>
                    </Row>
                </div>
                <div style={{display: 'flex'}}>
                    <FiRefreshCcw style={{paddingTop: '5px', fontSize: '20px', cursor: 'pointer'}} onClick={() => handleRefresh()}/> 
                    {isCardOpen ? 
                        <RiArrowUpSLine 
                        style={{fontSize: '25px', cursor: 'pointer'}} 
                        onClick={()=> setIsCardOpen(!isCardOpen)}/> 
                    : 
                        <RiArrowDownSLine 
                        style={{fontSize: '25px', cursor: 'pointer'}}
                        onClick={()=> handleExpandir()}/>}
                </div>               
            </div>
            <Collapse isOpen={isCardOpen} style={{paddingLeft: '5px'}}>
                <Row style={{marginTop: '15px'}}>
                    <div style={{width: '100%'}}>
                        <Button 
                        className='purpleButton' 
                        style={{width: '216px',margin: '12px 0 7px 80%'}}
                        onClick={()=> handleCorrigirInconsistencia()}>
                            <RiArrowRightSLine style={{fontSize: '20px', paddingBottom: '3px'}}/> 
                            Corrigir Inconsistência
                        </Button>
                        <span style={{marginLeft: '80%', fontSize: '12px', color: 'var(--color-cinza-medio)'}}> 
                            Você será redirecionado para outra tela
                        </span>
                    </div>
                </Row>
                {isCardOpen && (
                    <>
                    <Table striped {...getTableProps()} style={{marginTop: '20px'}}>
                        <thead>
                            {headerGroups.map((headerGroup) => (
                                <tr {...headerGroup.getHeaderGroupProps()}>
                                    {headerGroup.headers.map((column) => (
                                        <th>
                                            {column.render("Header")}
                                            <span className="float-right">
                                                {column.isSorted ?
                                                    (column.isSortedDesc ?
                                                        <BsArrowDown
                                                            {...column.getHeaderProps(column.getSortByToggleProps({ title: undefined }))}
                                                        />
                                                        :
                                                        <BsArrowUp
                                                            id="OrdenarAsc"
                                                            {...column.getHeaderProps(column.getSortByToggleProps({ title: undefined }))}
                                                        />)
                                                    :
                                                    <BsArrowDownUp
                                                        id="Ordenar"
                                                        {...column.getHeaderProps(column.getSortByToggleProps({ title: undefined }))}
                                                    />}
                                            </span>
                                        </th>
                                    ))}
                                </tr>
                            ))}
                        </thead>
                        <tbody {...getTableBodyProps()}>
                            {page.map(row => {
                                prepareRow(row)
                                return (
                                    <tr className="text-center" {...row.getRowProps()}>
                                        {row.cells.map((cell) => {
                                            return (<td {...cell.getCellProps()}>{cell.render("Cell")}</td>)
                                        })}
                                    </tr>
                                );
                            })}
                        </tbody>
                    </Table>
                        <Row className="pt-4">
                            <Col>
                                <span style={{ color: "var(--color-cinza-medio)" }}>Mostrando {rows} de {data.length}</span>
                            </Col>
                            <Col md={8}>
                                <Row className="float-right">
                                    <ReactPaginate
                                        previousLabel={'<'}
                                        nextLabel={'>'}
                                        breakLabel={'...'}
                                        breakClassName={'break-me'}
                                        initialPage={0}
                                        pageCount={pageCount}
                                        marginPagesDisplayed={2}
                                        pageRangeDisplayed={5}
                                        onPageChange={handlePageClick}
                                        containerClassName={"pagination"}
                                        subContainerClassName={"pages pagination"}
                                        activeClassName={"active"}
                                        forcePage={initialPage ? 0 : selectedPage}
                                    />
                                </Row>
                            </Col>
                        </Row>
                    </>
                )}
            </Collapse>
        </div>
    )
}